export const REGISTER_URL = '/register';
export const LOGIN_URL = '/login';